import { render, staticRenderFns } from "./RejectionReasonProductsEditForm.vue?vue&type=template&id=2e40b3ea&scoped=true&"
import script from "./RejectionReasonProductsEditForm.vue?vue&type=script&lang=ts&"
export * from "./RejectionReasonProductsEditForm.vue?vue&type=script&lang=ts&"
import style0 from "./RejectionReasonProductsEditForm.vue?vue&type=style&index=0&id=2e40b3ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e40b3ea",
  null
  
)

export default component.exports